// extracted by mini-css-extract-plugin
export var cat_main_title = "cta-module--cat_main_title--269b2";
export var cta_btn = "cta-module--cta_btn--fac14";
export var cta_content_wrap = "cta-module--cta_content_wrap--00505";
export var cta_info_content = "cta-module--cta_info_content--70b1b";
export var cta_info_wrap = "cta-module--cta_info_wrap--61d2d";
export var img_section = "cta-module--img_section--e940c";